module.exports = __webpack_public_path__ + "static/media/sem_monitoramento_novo.002e546e.png";